export const FETCH_SALES_RESULTS_GROUP_CATALOG = 'REPORTS/FETCH_SALES_RESULTS_GROUP_CATALOG';
export const SELECTED_CATALOGS_OPTIONS = 'REPORTS/SELECTED_CATALOGS_OPTIONS';
export const CLEAR_SELECTED_CATALOGS = 'REPORTS/CLEAR_SELECTED_CATALOGS';
export const SET_SESSION_RESULTS_LOADING = 'REPORTS/SET_SESSION_RESULTS_LOADING';
export const FETCH_SESSION_RESULTS_SUCCESS = 'REPORTS/FETCH_SESSION_RESULTS_SUCCESS';
export const SELECTED_LOTS_FOR_DISPUTES = 'REPORTS/SELECTED_LOTS_FOR_DISPUTES';
export const SELECT_ALL_ITEMS = 'SELECT_ALL_ITEMS';
export const DESELECT_ALL_ITEMS = 'DESELECT_ALL_ITEMS';
export const FETCH_SESSION_LOTS = 'REPORTS/FETCH_SESSION_LOTS';
export const FETCH_SESSION_LOTS_LOADING = 'REPORTS/FETCH_SESSION_LOTS_LOADING';
export const FETCH_DISPUTE_TYPES = 'REPORTS/FETCH_SESSION_DISPUTE_TYPES';
export const FETCH_DISPUTE_TYPES_LOADING = 'REPORTS/FETCH_SESSION_DISPUTE_TYPES_LOADING';
export const SUBMIT_DISPUTE_ACTION = 'REPORTS/SUBMIT_OPEN_DISPUTE_ACTION';
export const SUBMIT_DISPUTE_ACTION_LOADING = 'REPORTS/SUBMIT_OPEN_DISPUTE_ACTION_LOADING';
export const CLEAR_DISPUTES_DATA = 'REPORTS/CLEAR_DISPUTES_DATA';
export const SET_DEFAULT_FEEDBACK_MESSAGES = 'REPORTS/SET_DEFAULT_FEEDBACK_MESSAGES';
export const DEFAULT_FEEDBACK_MESSAGES_SUCCESS = 'REPORTS/DEFAULT_FEEDBACK_MESSAGES_SUCCESS';
export const SET_IS_DEFAULT_FEEDBACK_MESSAGES_LOADING = 'REPORTS/SET_IS_DEFAULT_FEEDBACK_MESSAGES_LOADING';
export const SET_IS_SUBMITTING_FEEDBACK = 'REPORTS/SET_IS_SUBMITTING_FEEDBACK';
export const SET_FEEDBACK_MESSAGES = 'REPORTS/SET_FEEDBACK_MESSAGES';
export const SET_REMOVE_FEEDBACK = 'REPORTS/SET_REMOVE_FEEDBACK';
export const SET_ADD_UPDATE_FEEDBACK = 'REPORTS/SET_ADD_UPDATE_FEEDBACK';
export const SET_FILTERED_SALES_GROUPS = 'SET_FILTERED_SALES_GROUPS';
export const SET_IS_SESSION_RESULTS_LOADING = 'SET_IS_SESSION_RESULTS_LOADING';

const initialState = {
  groups: undefined,
  filteredGroups: undefined,
  isLoadingGroups: true,
  selectedCatalogOptions: [],
  selectedLotsForDisputes: [],
  selectedAllDisputes: {},
  sessionResults: null,
  isLoadingSessionResults: false,
  sessionLots: {},
  sessionLotsLoading: false,
  disputeTypes: {},
  disputeTypesLoading: true,
  submitDisputeResult: {},
  submitActionLoading: false,
  defaultFeedbackMessages: undefined,
  feedbackMessage: {},
  isDefaultMessagesLoading: false,
  isDefaultFeedbackMessagesSuccess: false,
  isSubmittingFeedback: false
};

const getSelectedItems = (state, action) => {
  let items = state.selectedCatalogOptions;
  const catalogRefs = action.payload.catalogsData;
  if (action.payload.addItem) {
    items = catalogRefs.reduce((acc, data) => {
      if (!acc.some(({ catalogRef }) => catalogRef === data.catalogRef)) {
        acc.push(data);
      }
      return acc;
    }, items);
  } else {
    items = items.filter(
      ({ catalogRef: itemRef }) => !catalogRefs.some(({ catalogRef }) => itemRef === catalogRef)
    );
  }
  return items;
};

const getSelectedLotsForDisputes = (state, action) => {
  const { selectedLotsForDisputes } = state;
  const { lotRef, addItem } = action.payload;

  if (addItem) {
    const filteredItems = selectedLotsForDisputes.filter(ref => ref !== lotRef);
    return [...filteredItems, lotRef];
  }

  return selectedLotsForDisputes.filter(ref => ref !== lotRef);
};

export const setIsSessionResultsLoading = isLoading => ({
  type: SET_SESSION_RESULTS_LOADING,
  payload: isLoading
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SALES_RESULTS_GROUP_CATALOG:
      return {
        ...state,
        groups: action.payload,
        filteredGroups: action.payload,
        isLoadingGroups: false
      };
    case SET_FILTERED_SALES_GROUPS:
      return {
        ...state,
        filteredGroups: action.payload,
        isLoadingGroups: false
      };
    case SELECTED_CATALOGS_OPTIONS:
      return {
        ...state,
        selectedCatalogOptions: getSelectedItems(state, action)
      };
    case CLEAR_SELECTED_CATALOGS:
      return {
        ...state,
        selectedCatalogOptions: []
      };
    case SELECTED_LOTS_FOR_DISPUTES:
      return {
        ...state,
        selectedLotsForDisputes: getSelectedLotsForDisputes(state, action)
      };
    case SELECT_ALL_ITEMS: {
      const { memberID: selectAllMemberID, lotRefs } = action.payload;
      const existingLots = state.selectedAllDisputes[selectAllMemberID] || [];
      const uniqueLotRefs = [...new Set([...existingLots, ...lotRefs])];
      const existingLotsForDispute = state.selectedLotsForDisputes || [];
      const uniqueDisputeLotRefs = [...new Set([...existingLotsForDispute, ...lotRefs])];

      return {
        ...state,
        selectedAllDisputes: {
          ...state.selectedAllDisputes,
          [selectAllMemberID]: uniqueLotRefs
        },
        selectedLotsForDisputes: uniqueDisputeLotRefs
      };
    }

    case DESELECT_ALL_ITEMS: {
      const { memberID: deselectAllMemberID, lotRefs: deselectLotRefs } = action.payload;

      const updatedAllDisputes = Object.entries(state.selectedAllDisputes).reduce(
        (result, [memberID, lotRefs]) => {
          result[memberID] = memberID === deselectAllMemberID ? [] : lotRefs;
          return result;
        },
        {}
      );
      const updatedLotsForDisputes = state.selectedLotsForDisputes.filter(
        lotRef => !deselectLotRefs.includes(lotRef)
      );

      return {
        ...state,
        selectedAllDisputes: updatedAllDisputes,
        selectedLotsForDisputes: updatedLotsForDisputes
      };
    }

    case SET_SESSION_RESULTS_LOADING:
      return {
        ...state,
        isLoadingSessionResults: action.payload
      };

    case FETCH_SESSION_RESULTS_SUCCESS:
      return {
        ...state,
        sessionResults: action.payload
      };

    case FETCH_SESSION_LOTS:
      return {
        ...state,
        sessionLots: action.payload,
        sessionLotsLoading: false
      };

    case FETCH_SESSION_LOTS_LOADING:
      return {
        ...state,
        sessionLotsLoading: action.payload || true
      };

    case FETCH_DISPUTE_TYPES:
      return {
        ...state,
        disputeTypes: action.payload,
        disputeTypesLoading: false
      };

    case FETCH_DISPUTE_TYPES_LOADING:
      return {
        ...state,
        disputeTypesLoading: action.payload || true
      };

    case SUBMIT_DISPUTE_ACTION:
      return {
        ...state,
        submitDisputeResult: action.payload,
        submitActionLoading: false
      };

    case SUBMIT_DISPUTE_ACTION_LOADING:
      return {
        ...state,
        submitActionLoading: action.payload || true
      };

    case CLEAR_DISPUTES_DATA:
      return {
        ...state,
        sessionLots: { ...initialState.sessionLots },
        submitDisputeResult: { ...initialState.submitDisputeResult },
        disputeTypes: { ...initialState.disputeTypes },
        sessionLotsLoading: initialState.sessionLotsLoading,
        disputeTypesLoading: initialState.disputeTypesLoading,
        submitActionLoading: initialState.submitActionLoading
      };

    case SET_DEFAULT_FEEDBACK_MESSAGES:
      return {
        ...state,
        defaultFeedbackMessages: action.payload
      };

    case SET_IS_DEFAULT_FEEDBACK_MESSAGES_LOADING:
      return {
        ...state,
        isDefaultMessagesLoading: action.payload
      };

    case DEFAULT_FEEDBACK_MESSAGES_SUCCESS:
      return {
        ...state,
        isDefaultFeedbackMessagesSuccess: action.payload
      };

    case SET_IS_SUBMITTING_FEEDBACK:
      return {
        ...state,
        isSubmittingFeedback: action.payload
      };

    case SET_FEEDBACK_MESSAGES: {
      const { lotRef, feedback } = action.payload;
      return {
        ...state,
        feedbackMessage: {
          ...state.feedbackMessage,
          [lotRef]: feedback
        },
      };
    }

    case SET_REMOVE_FEEDBACK: {
      const { lotRef, memberID } = action.payload;
      const { groupedData } = state.sessionResults;

      const updatedGroupData = groupedData.map(group => {
        group.items = group.items.map(item => {
          if (item.feedback && item.memberID === memberID && item.lotRef === lotRef) {
            item.feedback = null;
            item.feedbackExistsForLot = false;
          }
          return item;
        });
        return group;
      });

      return {
        ...state,
        sessionResults: {
          ...state.sessionResults,
          groupedData: updatedGroupData,
        },
      };
    }

    case SET_ADD_UPDATE_FEEDBACK: {
      const { feedbacks, lotRefs } = action.payload;

      const updatedGroupData = JSON.parse(JSON.stringify(state.sessionResults.groupedData));

      feedbacks.forEach(feedbackItem => {
        const { defaultFeedback, feedbackId, message, positive } = feedbackItem;

        updatedGroupData.forEach(group => {
          group.items.forEach(item => {
            if (item.feedback && lotRefs.includes(item.lotRef)) {
              item.feedback.defaultFeedback = defaultFeedback;
              item.feedback.feedbackId = feedbackId;
              item.feedback.message = message;
              item.feedback.positive = positive;
              item.feedbackExistsForLot = true;
            }
          });
        });

        updatedGroupData.forEach(group => {
          const itemWithNoFeedback = group.items.find(item => !item.feedbackExistsForLot && lotRefs.includes(item.lotRef));
          if (itemWithNoFeedback) {
            itemWithNoFeedback.feedback = { message, feedbackId, positive, defaultFeedback };
            itemWithNoFeedback.feedbackExistsForLot = true;
          }
        });
      });

      return {
        ...state,
        sessionResults: {
          ...state.sessionResults,
          groupedData: updatedGroupData
        }
      };
    }

    default:
      return state;
  }
};
